module.exports = __webpack_public_path__ + "static/media/Colette Wing King Headboard - 180 cm_Blush Pink.0ee5c982.png";